/* eslint-disable linebreak-style */
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  html, body {  
    height: 100%; 
    width: 100%;  
    margin: 0;  
    padding: 0; 
  }     
  body {
    background-color: #f6f6f6;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
  }
  ul {
    padding-left: 0;
  }
`;

export default GlobalStyle;
